/**
 * program
 * Program APIs
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProgramContentBlockMngDtoContent } from './programContentBlockMngDtoContent';


export interface ProgramContentBlockMngDto { 
    /**
     * The type of the content block. Identifies the structure of \"content\" property.
     */
    contentBlockType: ProgramContentBlockMngDto.ContentBlockTypeEnum;
    content: ProgramContentBlockMngDtoContent;
}
export namespace ProgramContentBlockMngDto {
    export type ContentBlockTypeEnum = 'cardInformation' | 'stepProgressIndicator' | 'textInformation';
    export const ContentBlockTypeEnum = {
        CardInformation: 'cardInformation' as ContentBlockTypeEnum,
        StepProgressIndicator: 'stepProgressIndicator' as ContentBlockTypeEnum,
        TextInformation: 'textInformation' as ContentBlockTypeEnum
    };
}


